import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";

export default function FeatureItem({ data, slice }) {
  return (
    <div
      className={`group lg:border-b-[4px] lg:border-b-[#EFEFEF] lg:hover:border-b-[#EEB978] duration-200 p-[20px] lg:pt-[40px] lg:pb-[36px]
         lg:first:border-l-[0.5px] lg:last:border-r-[0.5px] 
         lg:first:border-l-[#EFEFEF] lg:last:border-r-[#EFEFEF]
         lg:first:hover:border-l-[#C5C5C5] lg:last:hover:border-r-[#C5C5C5] lg:border-r-[0.5px] border-b-[0.5px] border-[#C5C5C5] w-full`}
    >
      <div className="w-full max-w-[335px] mx-auto flex flex-nowrap gap-[14px] md:gap-[20px] items-center">
        <div>
          <div className="relative h-[70px] w-[70px] md:h-[85px] md:w-[85px] rounded-full border-[1.5px] border-[#EEC593]">
            {data.icon?.url && (
              <PrismicNextImage
                className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] w-[30px] h-[30px] md:w-[45px] md:h-[45px] "
                field={data.icon}
                fallbackAlt=""
              />
            )}
          </div>
        </div>
        <div className="text-[#1F2223]">
          <PrismicRichText field={data?.text} />
        </div>
      </div>
    </div>
  );
}
